import React from 'react'
import { getFormatDate, outputMoney } from '@/public/utils'
import { InputNumber, Tooltip, Tag } from 'antd'
import { getFormatDateIsNull, updateBills } from '../common/utils'

import _, { get } from 'lodash'
import moment from 'moment'

export const billTypeOptions = [
  { label: '增值税专用发票（纸质发票）', value: '01' },
  { label: '增值税电子专用发票', value: '08' },
  { label: '全电子发票', value: '31' },
  { label: '增值税普通发票（纸质发票）', value: '02' },
  { label: '增值税电子普通发票', value: '03' },
  { label: '形式发票', value: '00' },
]
export const StatusColorMap = { "00": "#bfbfbf", "01": "#0e77d1", "02": "#00a854", "03": "#f04134", "04": "#ffbf00", "05": "#bfbfbf" }

export const signTypeMap = { '00': '电子', '01': '实物' }

export const getColumns = (data = {}) => {
  const { enums, updateFun, bills,type, notneedDelete, showStatus,disabled } = data
  var columns = [
    {
      title: "发票单号",
      key: "invoice_id",
      dataIndex: "invoice_id",
      align:'center',
      render: (text, record) => {
        return get(record, 'invoice_id') || '-'
      }
    },
    {
      title: "发票号码",
      key: "invoice_no",
      dataIndex: "invoice_no",
      align:'center',
      render: (text, record) => {
        return get(record,'electronic_invoice_no')||get(record, 'invoice_no') || '-'
      }
    },
    {
      title: "发票代码",
      key: "invoice_code",
      dataIndex: "invoice_code",
      width:130,
      align:'center',
      render: (text, record) => {
        return get(record, 'invoice_code') || '-'
      }
    },
    {
      title: "开票日期",
      key: "invoice_date",
      dataIndex: "invoice_date",
      width:100,
      align:'center',
      render: (text, record) => {
        return <span>
          {getFormatDateIsNull(get(record, 'invoice_date') ? moment(get(record, 'invoice_date')) : null,)}
        </span>
      }
    },

    {
      title: "价税合计金额",
      key: "total_amount",
      dataIndex: "total_amount",
      align:'center',
      render: (text, record) => {
        return <div style={{textAlign:"right"}}>{outputMoney(get(record, 'total_amount') || 0)}</div>
      }
    },
    {
      title: "税额",
      key: "tax_amount",
      dataIndex: "tax_amount",
      align:'center',
      render: (text, record) => {
        return <div style={{textAlign:"right"}}>{outputMoney(get(record, 'tax_amount') || 0)}</div>
      }
    },
    {
      title: "可匹配金额",
      key: "remain_amount",
      dataIndex: "remain_amount",
      align:'center',
      render: (text, record) => {
        return <div style={{textAlign:"right"}}>{outputMoney(get(record, 'remain_amount') || 0) || 0}</div>
      }
    },
    {
      title: "本次匹配金额",
      key: "match_invoice_amount",
      dataIndex: "match_invoice_amount",
      width:140,
      align:'center',
      render: (text, record) => {
        if(disabled||get(record,'is_occupy')){
          return (
              get(record,'is_occupy')?
              <Tooltip placement="topLeft" title={<span style={{fontSize:12}}>占用中：{(get(record.match_id_list,'length') > 1 ? get(record,'match_id_list').join(',') : (get(record,'match_id_list[0]') || ''))}</span>}>
                <div>{outputMoney(get(record, 'match_invoice_amount'))}</div>
              </Tooltip>
            :<div style={{textAlign:"right"}}>{outputMoney(get(record, 'match_invoice_amount'))}</div>
            )
        }
        else{
          return (
            <InputNumber
            precision={2}
            min={get(record, 'remain_amount') < 0 ? get(record, 'remain_amount') : 0}
            max={get(record, 'remain_amount') < 0 ? 0 : get(record, 'remain_amount')}
            style={{ width: "120px" }}
            value={get(record, 'match_invoice_amount')}
            onChange={updateBills.bind(this, bills, record, updateFun)} />
          )
        }
      }
    },
  ]
  var handle = [
    {
      title: "操作",
      key: "invoice_id",
      dataIndex: "invoice_id",
      width: 100,
      align:'center',
      render: (text, record) => {
        return (
          <a onClick={() => { updateFun(_.differenceBy(bills, [{ invoice_id: get(record, 'invoice_id') }], 'invoice_id'),get(record, 'invoice_id')) }}>删除</a>

        )
      }
    }
  ]
  var newColumns = _.cloneDeep(columns)
  if(_.keys(get(enums, '发票类型枚举值(系统)')).includes(String(type))){
    newColumns = _.differenceBy(columns,[{'title': "发票单号"}],'title')
  }
  if (!notneedDelete&&!disabled) {
    newColumns = newColumns.concat(handle)
  }
  // if (showStatus) {
  //   var statusColumnItem = {
  //     title: "发票状态",
  //     key: "invoice_status",
  //     dataIndex: "invoice_status",
  //     align:'center',
  //     render: (text, record) => {
  //       text = get(record, 'invoice_status')
  //       //要分场景，对于人工录入的发票，那个是发票单，取的是发票审批状态；对于系统采集的发票，取的是发票状态
  //       //财务那边：审核状态和发票状态都是正常才会返回，所以现在写死
  //       return <div>
  //         <span style={{
  //           display: 'inline-block', width: 6, height: 6, marginRight: 4, borderRadius: '50%', backgroundColor:StatusColorMap['02']
  //         }} />正常</div>
  //     }
  //   }
  //   newColumns.splice(3,0,statusColumnItem)
  // }
  return newColumns
}

export const getAccountColumns = () => {
  return [
    {
      title: "对账单号",
      key: "supplier_account_code",
      dataIndex: "supplier_account_code",
      width: 150,
      align:'center',
      render: (text, record) => {
        return <a href={`/main/supplierRecantion/listDetails?code=${get(record,'supplier_account_code')}`} target={'_blank'}>{get(record,'supplier_account_code')}</a>
      }
    },
    {
      title: "账期",
      key: "supplier_account_begin_date",
      dataIndex: "supplier_account_begin_date",
      width: 150,
      align:'center',
      render: (text, record) => {
        return <span>
          {getFormatDateIsNull(get(record, 'supplier_account_begin_date'),)}
          ～
          {getFormatDateIsNull(get(record, 'supplier_account_end_date'))}
        </span>
      }
    },
    {
      title: "出账时间",
      key: "add_time",
      dataIndex: "add_time",
      width: 150,
      align:'center',
      render: (text, record) => {
        return <span style={{textAlign:"right"}}>{get(record, 'add_time') ? getFormatDate(get(record, 'add_time')) : "-"}</span>
      }
    },
    {
      title: "备注",
      key: "remark",
      dataIndex: "remark",
      width: 150,
      align:'center',
      render: (text, record) => {
        return <span>{get(record, 'remark') || '-'}</span>
      }
    },
    {
      title: "账单总金额（元）",
      key: "statement_amount",
      dataIndex: "statement_amount",
      align:'center',
      width: 150,
      render: (text, record) => {
        return <div style={{textAlign:"right"}}>{outputMoney(get(record, 'statement_amount') || 0)}</div>
      }
    },
    {
      title: "剩余可匹配金额（元）",
      key: "invoice_remain_amount",
      dataIndex: "invoice_remain_amount",
      width: 150,
      align:'center',
      render: (text, record) => {
        return <div style={{textAlign:"right"}}>{outputMoney(get(record, 'invoice_remain_amount') || 0)}</div>
      }
    },
    {
      title: "本次匹配金额（元）",
      key: "match_invoice_amount",
      dataIndex: "match_invoice_amount",
      width: 150,
      align:'center',
      render: (text, record) => {
        return <div style={{textAlign:"right"}}>{outputMoney(get(record, 'match_invoice_amount') || 0)}</div>
      }
    },
  ]
}

export const mutipleNote = { 
  8: '友情提醒：发票左上角（或右上角）有发票号码，如果连续2张或2张以上发票号码相连代表是连号发票。例如，有5张发票号码分别是12345510、12345511、12345512，12345513，12345514.请在起始发票号码中录入12345510，在结束发票号码中录入12345514即可。', 
20: '友情提醒：发票左上角（或右上角）有发票号码，如果连续2张或2张以上发票号码相连代表是连号发票。例如，有3张发票号码分别是22312000000001574080、22312000000001574081、22312000000001574082.请在起始发票号码中录入22312000000001574080，在结束发票号码中录入22312000000001574082即可。' }





// WEBPACK FOOTER //
// ./src/pages/billVerification/match/detail/config.js